import Vue from 'vue'
import Vuex from 'vuex'
import api from '../services/api'
import permissions from './permissions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false,
    userProfile: null,
    alert: {alert: false},
    userLoading: false,
    pageLoading: false, 
  },
  getters: {
    loggedIn (state) {
      return state.loggedIn
    },
    loadedUser (state) {
      return state.userProfile
    },
    loadedAlert (state) {
      return state.alert
    },
    loadedUserLoading (state) {
      return state.userLoading
    },
    loadedPageLoading (state) {
      return state.pageLoading
    }
  },
  mutations: {
    SET_LOGGED_IN(state, payload) {
      state.loggedIn = payload;
    },
    SET_USER(state, payload) {
      state.userProfile = payload
    },
    setAlert (state, payload) {
      state.alert = payload
    },
    setUserLoading (state, payload) {
      state.userLoading = payload
    },
    setPageLoading (state, payload) {
      state.pageLoading = payload
    }
  },
  actions: {
    async getUser({commit, state}, preloadedUser = null) {
      if(state.userProfile) {
        return
      }
      commit('setUserLoading', true)
      
      let user = preloadedUser;
      if (!user) {
          user = await api.auth.getMe();
      }
      
      if(user) {
         console.log('getUser: Loaded user', user);
         commit('SET_USER', user)
         commit('setUserLoading', false)
      } else {
         console.error('getUser: No user found');
         commit('setUserLoading', false)
      }
  },

  createAlert ({commit}, payload) {
    const data = {
        alert: true,
        type: payload.type,
        message: payload.message
    }
    commit('setAlert', data)
    setTimeout(() => {
        commit('setAlert', {alert: false})
    }, 3000);
},

  
},
  modules: {
    permissions
  }
})


